import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/densa/Header";
import Hero from "@/components/densa/Hero";
import Marquee from "@/components/densa/Marquee";
import WhatIs from "@/components/densa/WhatIs";
import Benefits from "@/components/densa/Benefits";
import Diva from "@/components/densa/Diva";
import Showcase from "@/components/densa/Showcase";
import DownloadCta from "@/components/densa/DownloadCta";
import Gallery from "@/components/densa/Gallery";
import Blog from "@/components/densa/Blog";
import Vision from "@/components/densa/Vision";
import Contact from "@/components/densa/Contact";
import Footer from "@/components/densa/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#F8FAF9] font-sans text-slate-900 antialiased">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <WhatIs />
        <Benefits />
        <Diva />
        <Showcase />
        <DownloadCta />
        <Gallery />
        <Blog />
        <Vision />
        <Contact />
      </main>
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
